export default "__VITE_ASSET__34cdc01c__"